import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import handleHospital from "@/services/modules/hospital";
import htmlToPdfmake from 'html-to-pdfmake';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
    SulaimanLipi: {
        normal: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
    }
}

const pdfPrinter = () => { 

    const { dateOfBarthConvertToAge } = handleHospital();

    const exportToPDF = (company, investigation, barcode, qrcode, 
                        barcodePatient, userName, btnTitle, isHideHeader = false, 
                        isHideFooter = false, isDownload = false, customizationFields = []) => {

        const isSignature = customizationFields['signature_prepared_by_signature'] || 
                            customizationFields['signature_approved_by_signature']
        
        const isBorder = customizationFields['heading_left_details_border'];

        let margins = null;

        if(customizationFields['extra_settings_margin'] && customizationFields['extra_settings_margin'].is_active) {
            margins = customizationFields['extra_settings_margin'].value
        }

        var doc = {
            pageSize: 'A4',
            pageMargins: getPageMargin(isSignature, margins),
            header: getHeader(company, customizationFields),
            footer: function (currentPage, pageCount) {
                const items = [];

                if (currentPage === pageCount && ! isSignature) {
                    items.push(getFooterTop(investigation, customizationFields));
                }
                
                items.push(getFooter(userName, qrcode, customizationFields));

                return {
                    margin: margins ? [margins.left, margins.top, margins.right, margins.bottom] : [60, 30, 60, 80],
                    layout: 'noBorders',
                    stack: items
                };
            },
            content: getContent(investigation, barcode, barcodePatient, userName, btnTitle, isBorder),

            styles : {
                header: {
                    fontSize: 16,
                },
                tableHeader: {
                    fontSize: 16,
                },
                tableExample: {
                    fontSize: 10,
                },
            },
            
            defaultStyle: {
                color: 'black',
                fontSize: 10,
                font: 'SulaimanLipi'
            },

            info: {
                title: investigation.id
            }
        }

        pushIntoTable(doc, investigation.formattedGenerals, investigation, investigation.antibiotics_dropdown, customizationFields);

        if(isSignature) {
            doc.content.push(getFooterTop(investigation, customizationFields));
        }

        const pdfDocGenerator = pdfMake.createPdf(doc);
        if(isDownload) {
            pdfDocGenerator.download('investigation-report.pdf');
            return;
        }
        pdfDocGenerator.print();
    }

    const calculateAge = (birthday) => {
        const {year, month, day} = dateOfBarthConvertToAge(birthday)
        return `${year}Y, ${month}M, ${day}D`
    }

    const formatDate = (date) => {
        var formattedDate = date.toISOString().split('T')[0];
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var amOrPm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12;
        var formattedTime = hours + ':' + (minutes < 10 ? '0' : '') + minutes + ' ' + amOrPm;
        return formatToDdMmYy(formattedDate) + ' ' + formattedTime
    }

    const formatToDdMmYy = (date) => {
        var dat = date.split('-');
        return `${dat[2]}-${dat[1]}-${dat[0]}`;
    }

    const getHeader = (company, customizationFields) => {
        const showCoverPhoto = shouldInclude(customizationFields, 'heading_left_cover_photo') && company.cover_photo64;

        // If cover photo is enabled, show only that and nothing else
        if (showCoverPhoto) {
            return {
                margin: [0, 0, 0, 10],
                columns: [
                    {
                        image: company.cover_photo64,
                        width: 600,
                        alignment: 'center',
                    }
                ]
            };
        }

        // Otherwise, show normal header fields
        return {
            margin: [60, 25, 60, 10],
            columns: [
                shouldInclude(customizationFields, 'heading_left_logo') && company.logo64
                    ? {
                        alignment: 'left',
                        image: company.logo64,
                        maxHeight: 60
                    }
                    : null,
                {
                    alignment: 'right',
                    stack: [
                        shouldInclude(customizationFields, 'heading_right_company_name') && company.name ? company.name : '',
                        shouldInclude(customizationFields, 'heading_right_company_address') && company.address ? 'Address: ' + company.address : '',
                        shouldInclude(customizationFields, 'heading_right_company_phone') && company.phone ? 'Phone: ' + company.phone : '',
                        shouldInclude(customizationFields, 'heading_right_company_email') && company.email ? 'E-mail: ' + company.email : '',
                        shouldInclude(customizationFields, 'heading_right_vat_reg_number') && company.vat_no ? 'VAT Reg No: ' + company.vat_no : '',
                    ]
                }
            ].filter(Boolean)
        };
    };

    const getContent = (investigation, barcode, barcodePatient, userName, btnTitle, isBorder) => {

        return  [
            {
                alignment: 'justify',
                margin: [0, 20, 0, 5],
                columns: [
                    {
                        svg: barcodePatient
                    },
                    {
                        svg: barcode,
                        alignment: 'right',
                    },
                ]
            },
            {
            // Bordered section
            table: {
                widths: ['*'],
                body: [
                    [
                        {
                            columns: [
                                // Left side patient info
                                {
                                    width: '70%',
                                    stack: [
                                        { columns: [{ width: '30%', text: 'Patient ID:', bold: true }, { width: '70%', text: investigation.contact_profile.serial_no }]},
                                        { columns: [{ width: '30%', text: 'Patient Name:', bold: true }, { width: '70%', text: investigation.contact_profile.full_name }]},
                                        { columns: [{ width: '30%', text: 'Age:', bold: true }, { width: '70%', text: calculateAge(investigation.contact_profile.birthday) + ' | Gender: ' + investigation.contact_profile.gender }]},
                                        { columns: [{ width: '30%', text: 'Mobile No:', bold: true }, { width: '70%', text: investigation.contact_profile.mobile_no }]},
                                        { columns: [{ width: '30%', text: 'Ref By:', bold: true }, { width: '70%', text: investigation.service_resource.consultant ? investigation.service_resource.consultant.full_name : '' }]},
                                        { columns: [{ width: '30%', text: 'Specimen:', bold: true }, { width: '70%', text: getUniqueSamples(investigation.formattedGenerals) }]},
                                    ]
                                },
                                // Right side invoice info
                                {
                                    width: '30%',
                                    stack: [
                                        { columns: [{ width: '50%', text: 'INVOICE NO:', bold: true, alignment: 'left' }, { width: '50%', text: investigation.bill_number, alignment: 'right' }]},
                                        { columns: [{ width: '50%', text: 'INVOICE DATE:', bold: true, alignment: 'left' }, { width: '50%', text: formatToDdMmYy(investigation.date), alignment: 'right' }]},
                                    ]
                                }
                            ]
                        }
                    ]
                ]
            },
            layout: isBorder ? {
                hLineWidth: () => 1,
                vLineWidth: () => 1,
                hLineColor: () => '#000',
                vLineColor: () => '#000',
                paddingLeft: () => 8,
                paddingRight: () => 8,
                paddingTop: () => 6,
                paddingBottom: () => 6
            } : 'noBorders',
                margin: [0, 0, 0, 5]
            },
            {
                text: btnTitle,
                style: 'header',
                alignment: 'center',
                bold: true,
                color: 'black',
            },
        ]
    }

    const getFooter = (userName, qrcode, customizationFields) =>{
        return {
            columns: [
                {
                    columns: [
                       shouldInclude(customizationFields,'footer_qrcode') ? {
                            svg: qrcode
                        } : '',

                        shouldInclude(customizationFields,'footer_note') ? {
                            width: '90%',
                            alignment: 'left',
                            text: 'N.B: This is a system generated documents and requires no manual signature.',
                            margin: [5, 53, 0, 0],
                            fontSize: 8
                        } : ''
                    ]
                },

                shouldInclude(customizationFields,'footer_printed_by') ? {
                    width: '20%',
                    alignment: 'right',
                    fontSize: 8,
                    margin: [0, 33, 0, 0],
                    stack: [
                        {
                            text: 'Printed by',
                            bold: true
                        },
                        {
                            text: userName
                        },
                        {
                            text: formatDate(new Date())
                        }
                    ]
                } : ''
            ]
        }
    }

    const getFooterTop = (investigation, customizationFields) => {
        return {
            alignment: 'justify',
            margin: [0, 30, 0, 20],
            stack: [{
                margin: [0, 0, 0, 5],
                columns: [
                    shouldInclude(customizationFields, 'signature_prepared_by_signature') ? {
                        width: '50%',
                        stack: [
                            investigation.prepared_by_resource && investigation.prepared_by_resource.signature_photo64 && {
                                image: investigation.prepared_by_resource.signature_photo64,
                                alignment: 'left',
                                fit: [100, 40]
                            },
                        ]
                    } : '',
                    shouldInclude(customizationFields, 'signature_approved_by_signature') ? {
                        width: '50%',
                        alignment: 'right',
                        stack: [
                             investigation.approved_by_resource && investigation.approved_by_resource.signature_photo64 && {
                                image: investigation.approved_by_resource.signature_photo64,
                                alignment: 'right',
                                fit: [100, 40]
                            },
                        ]
                    } : '',
                ]},
                {
                columns: [
                    {
                        width: '50%',
                        stack: [
                            {
                                text: investigation.prepared_by_resource ? investigation.prepared_by_resource.short_description : '',
                                alignment: 'left',
                                width: '50%'
                            }
                        ]
                    },
                    {
                        width: '50%',
                        alignment: 'right',
                        stack: [
                            {
                                text: investigation.approved_by_resource ? investigation.approved_by_resource.short_description : '',
                                alignment: 'right',
                                width: '50%'
                            }
                        ]
                    },
                ]},
            ]
        }
    }

    const pushIntoTable = (doc, reports, investigation, antibioticsDropDown, customizationFields) => {
        const antibioticsTableData = {};
        const generalTableData = {};
        const generalTextData = {};

        Object.entries(reports).forEach(([head, group]) => {
            const antibiotics = group.filter(item => item.investigation_report_type === 'antibiotics');
            const generalTable = group.filter(item => item.investigation_report_type === 'general_table');
            const generalText = group.filter(item => item.investigation_report_type === 'general_text');

            antibiotics.length && (antibioticsTableData[head] = antibiotics);
            generalTable.length && (generalTableData[head] = generalTable);
            generalText.length && (generalTextData[head] = generalText);
        });

        if(Object.keys(generalTableData).length > 0) {
            const tableHeader = getTableHeader()
        
            const content = {
                style: 'tableExample',
                margin: [0, 10, 0, 0],
                table: {
                    widths: ['*', '20%', '10%', '30%'],
                    body: []
                },
                layout: {
                    fillColor: function (rowIndex, node, columnIndex) {
                      return '';
                    },
                    hLineWidth: function (i, node) {
                      return 0.5;
                    },
                    vLineWidth: function (i, node) {
                      return 0;
                    },
                    hLineColor: function (i, node) {
                      return '#82868b'; 
                    },
                    vLineColor: function (i, node) {
                      return (i === 0 || i === node.table.widths.length) ? '#82868b' : '#dddddd';
                    },
                }
            }
        
            content.table.body.push(tableHeader);

            Object.entries(generalTableData).forEach(([head, items]) => {
                content.table.body.push(getRowTitle(head));
                setTableContent(items, content);
            });
        
            doc.content.push(content);
        }

        generalTextData && Object.keys(generalTextData).forEach((head, items) => {
            doc.content.push({
                text: head,
                bold: true,
                margin: [0, 15, 0, 5],
                fontSize: 12,
            });

            doc.content.push(getTextContent(generalTextData[head]));
        });

        const groupKeys = Object.keys(antibioticsTableData);
        if (!groupKeys.length) return;

        groupKeys.forEach(head => {
            doc.content.push({
                text: head,
                bold: true,
                margin: [0, 15, 0, 5],
                fontSize: 12,
            });

            doc.content.push(getAntibioticsTable(head, antibioticsTableData[head], antibioticsDropDown));

            doc.content.push({
                table: {
                    widths: ['*', '*', '*'],
                    body: [
                        [
                            { text: 'R: Resistant', alignment: 'center', border: [false, false, false, false] },
                            { text: 'M: Moderate', alignment: 'center', border: [false, false, false, false] },
                            { text: 'S: Sensitive', alignment: 'center', border: [false, false, false, false] },
                        ]
                    ]
                },
                layout: 'noBorders',
                margin: [0, 5, 0, 10]
            });
        });
    }

    const getTextContent = (items) => {
        if (!items || !items.length) return [];

        const content = [];

        items.forEach(item => {
            if (!item.result) return;

            const pdfContent = htmlToPdfmake(item.result);
            Array.isArray(pdfContent) 
                ? content.push(...pdfContent) 
                : content.push(pdfContent);
        });

        return content;
    };

    const setTableContent = (reports, content) => {
        for(const report of reports){
            const row = getRowData(report);
            if (row) {
                content.table.body.push(row);
            }
        }
    }

    const getAntibioticsTable = (head, antibiotics, antibioticsDropDown) => {
        const half = Math.ceil(antibiotics.length / 2);
        const leftSide = antibiotics.slice(0, half);
        const rightSide = antibiotics.slice(half);

        const makeTableBody = (items, startIndex = 1) =>
            items.map((item, i) => [
                { text: (startIndex + i).toString(), alignment: 'center', margin: [0, 0, 3, 0] },
                { text: item.name || '', margin: [2, 0, 0, 0] },
                { text: antibioticsDropDown[item.result] || '', alignment: 'center' }
            ]);

        const leftBody = makeTableBody(leftSide, 1);
        const rightBody = makeTableBody(rightSide, half + 1);

        const maxRows = Math.max(leftBody.length, rightBody.length);
        const rows = [];

        for (let i = 0; i < maxRows; i++) {
            const left = leftBody[i] || [{ text: '' }, { text: '' }, { text: '' }];
            const right = rightBody[i] || [{ text: '' }, { text: '' }, { text: '' }];
            rows.push([...left, ...right]);
        }

        return {
            style: 'tableExample',
            margin: [0, 5, 0, 10],
            table: {
                widths: [15, '*', 50, 15, '*', 50],
                body: [
                    [
                        { text: 'SL', bold: true },
                        { text: 'Sensitivity Test', bold: true },
                        { text: 'Result', bold: true, alignment: 'center' },
                        { text: 'SL', bold: true },
                        { text: 'Sensitivity Test', bold: true },
                        { text: 'Result', bold: true, alignment: 'center' }
                    ],
                    ...rows
                ]
            },
            layout: {
                hLineWidth: () => 0.5,
                vLineWidth: () => 0.5,
            }
        };
    };

    const getTableHeader = () => {
        return [
            { text: 'Parameter', bold: true },
            { text: 'Result', bold: true },
            { text: 'Unit', bold: true },
            { text: 'Reference value', bold: true }
        ];
    }
    
    const getRowTitle = (title) => {
        return [ 
            { text: title, bold: true, colSpan: 4, margin: [0, 0, 0, 0]},
            {},
            {},
            {},
        ];
    }
    
    const getRowData = (report) => {
        if(! report.result) return null;

        return [
            { text: report.name, margin: [15, 0, 0, 0]},
            { text: report.result },
            { text: report.unit },
            { text: report.reference_value } 
        ];
    }

    const getUniqueSamples = (formattedGenerals) => {
        const samplesSet = new Set();

        Object.values(formattedGenerals).forEach(group => {
            group.forEach(item => {
                if (item.sample) {
                    samplesSet.add(item.sample);
                }
            });
        });

        const capitalizeWords = (str) => {
            return str
                .split('_')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                .join(' ');
        };

        return Array.from(samplesSet)
            .map(s => capitalizeWords(s))
            .join(', ');
    };

    const getPageMargin = (isSignature, margins) => {
        if(isSignature) {
            return [ 60, 100, 60, 100 ];
        }

        if(margins) {
            return [ margins.left, margins.top, margins.right, margins.bottom ]
        }

        return [ 60, 100, 60, 190 ];
    }

    const shouldInclude = (customizationFields, key) => Object.keys(customizationFields).length === 0 || customizationFields[key];

    return {
        exportToPDF
    }
}

export default pdfPrinter;
